import { customer } from './types/customer'
import { settlement } from './types/settlement'

type Api = { [key: string]: (...args: any) => any };

const wrap = <A extends Api>(api: A) => {
  return async function <T extends keyof A> (path: T, ...r: Parameters<A[T]>) {
    const _ = api[path] as any
    return _(...r as any) as ReturnType<A[T]>
  }
}

const request = {
  customer: wrap(customer),
  settlement: wrap(settlement)
}

export default request

export { customer, settlement }
